import React from 'react';
import { Text } from '@rneui/themed';
import { StyleSheet } from 'react-native';
import { View } from './';
export const BulletItem = ({ text, style = {} }) => (React.createElement(View, { transparent: true, style: { flexDirection: 'row' } },
    React.createElement(Text, null, '\u2022'),
    React.createElement(Text, { style: StyleSheet.flatten([
            {
                flex: 1,
                paddingLeft: 10,
            },
            style,
        ]) }, text)));
//# sourceMappingURL=BulletItem.js.map